export { preloadPostOfficeConfluenceSideNav } from '../src/preloadConfluenceSideNav.ts';
